// Copyright (C) 2021 TANNER AG

import gql from "graphql-tag";

export const FullTSTopicFragment = gql`
    fragment FullTSTopicFragment on TSTopic {
        id
        title
        slug
        intro
        order
        active
        banner
        thumbnail(locales: [$lang, de]) {
            handle
            fileName
            width
            height
            url
            mimeType
        }
        tsContents {
            order
            title
            content
            table
            quote
            info
            assetWithDescriptions(orderBy: sortIndex_ASC) {
                id
                asset(locales: [$lang, de]) {
                    handle
                    fileName
                    width
                    height
                    url
                    mimeType
                }

                description
                localizedAsset {
                    handle
                    fileName
                    width
                    height
                    url
                    mimeType
                }
            }
            image(locales: [$lang, de]) {
                handle
                fileName
                width
                height
                url
                mimeType
            }
            hotspots(orderBy: sortIndex_ASC) {
                posX
                posY
                headline
                description
            }
            twoColumns
            youTubeLink
        }
        tsChapters(orderBy: order_ASC) {
            id
            slug
            title
            order
            intro
            thumbnail(locales: [$lang, de]) {
                handle
                fileName
                width
                height
                url
                mimeType
            }
        }
    }
`;

export default gql`
    query TSTopic($slug: String!, $lang: Locale!, $stage: Stage!) {
        tSTopic(where: { slug: $slug }, locales: [$lang], stage: $stage) {
            ...FullTSTopicFragment
        }
    }
    ${FullTSTopicFragment}
`;



// WEBPACK FOOTER //
// ./src/queries/tSTopic.js